import SectionHeader from './SectionHeader';

const panels = [
  'https://readdy.ai/api/search-image?query=Dark%20muted%20anime%20manga%20panel%20illustration%20scene%20in%20soft%20night%20palette%2C%20gentle%20indigo%20and%20warm%20dim%20lighting%2C%20calm%20cinematic%20mood%2C%20subtle%20detail%2C%20comfortable%20low%20brightness%20reading%20composition&width=800&height=360&seq=night-panel-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Dark%20muted%20anime%20manga%20panel%20illustration%20of%20two%20characters%20conversing%20at%20night%2C%20soft%20dim%20moonlight%20and%20indigo%20tones%2C%20warm%20low%20glow%20highlights%2C%20calm%20readable%20cinematic%20composition&width=800&height=360&seq=night-panel-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Dark%20muted%20anime%20manga%20panel%20illustration%20of%20a%20night%20city%20street%20with%20soft%20lantern%20glow%2C%20deep%20indigo%20and%20warm%20dim%20amber%20lighting%2C%20peaceful%20low%20brightness%20cinematic%20composition&width=800&height=360&seq=night-panel-3&orientation=landscape',
];

export default function NightShowcase() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 md:px-6 lg:grid-cols-2">
        <div>
          <SectionHeader
            eyebrow="夜间模式"
            title="深夜追更，也要护眼舒适"
            desc="开启夜间模式，柔和深色画面降低蓝光刺激，让眼睛在长时间的畅快阅读中也能得到保护。"
          />
          <ul className="mt-7 space-y-4">
            {[
              { icon: 'ri-eye-2-line', t: '低蓝光柔光', d: '自动降低有害蓝光，缓解长时间阅读的视觉疲劳' },
              { icon: 'ri-contrast-2-line', t: '智能对比度', d: '优化文字与画面层次，深色下依旧清晰易读' },
              { icon: 'ri-sun-line', t: '一键切换', d: '日间夜间随心切换，阅读状态实时记忆' },
            ].map((it) => (
              <li key={it.t} className="flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${it.icon} text-lg`}></i>
                </span>
                <div>
                  <div className="text-sm font-bold text-foreground-950">{it.t}</div>
                  <div className="mt-0.5 text-xs leading-relaxed text-foreground-600 md:text-sm">{it.d}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
          <div className="overflow-hidden rounded-lg bg-foreground-950 p-3 md:p-4">
            <div className="flex items-center justify-between px-1 pb-3">
              <div className="flex items-center gap-2 text-[11px] text-foreground-300">
                <i className="ri-arrow-left-line"></i>
                星海奇缘 · 第 168 话
              </div>
              <div className="flex items-center gap-1 rounded-full bg-background-700/40 px-2 py-0.5 text-[10px] text-foreground-200">
                <i className="ri-moon-clear-line"></i>
                夜间模式
              </div>
            </div>
            <div className="space-y-2.5">
              {panels.map((src, i) => (
                <div key={i} className="relative aspect-[16/7] w-full overflow-hidden rounded-md bg-background-800/60">
                  <img
                    src={src}
                    alt={`夜间模式漫画阅读画面示意 ${i + 1}`}
                    className="h-full w-full object-cover"
                  />
                </div>
              ))}
            </div>
            <div className="mt-3 flex items-center justify-center gap-1.5 text-foreground-300">
              {[1, 2, 3, 4].map((n) => (
                <span
                  key={n}
                  className={`h-1.5 w-1.5 rounded-full ${n === 2 ? 'bg-accent-400' : 'bg-background-600'}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}